import { Component } from '@angular/core';
import { VehicleHistoryDrawerService } from 'src/app/historial/services/vehicle-history-drawer.service';
import { MapService } from 'src/app/vehicles/services/map.service';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import {
  VehicleHistoryDrawerData,
  VehicleHistoryDrawerParams,
} from 'src/app/historial/models/vehicle-history-drawer.model';

@Component({
  selector: 'app-maparea',
  templateUrl: './maparea.component.html',
  styleUrls: ['./maparea.component.scss'],
})
export class MapareaComponent {
  isHiddenHistoryMap$: Observable<boolean>;
  isDestroyedHistoryMap$: Observable<boolean>;
  dataHistoryDrawer$: Observable<VehicleHistoryDrawerData | null>;

  constructor(
    private vehicleHistoryDrawerService: VehicleHistoryDrawerService,
    private mapService: MapService
  ) {
    this.isHiddenHistoryMap$ =
      this.vehicleHistoryDrawerService.getStateHiddenHistoryDrawer.pipe(
        tap((_) => this.centerMap(400))
      );
    this.isDestroyedHistoryMap$ =
      this.vehicleHistoryDrawerService.getStateDestroyedHistoryDrawer.pipe(
        tap((_) => this.centerMap(100))
      );

    this.dataHistoryDrawer$ =
      this.vehicleHistoryDrawerService.getDataHistoryDrawer.pipe(
        filter(
          (
            data: VehicleHistoryDrawerParams | null
          ): data is VehicleHistoryDrawerParams => data !== null
        ),
        map((data: VehicleHistoryDrawerParams): VehicleHistoryDrawerData => {
          return {
            variant: data.is_custom ? 'custom' : 'default',
            imei: data.imei,
          };
        }),
        tap((data: VehicleHistoryDrawerData) => {
          if (data) {
            this.centerMap(400);
          }
        })
      );
  }

  private centerMap(waitTime: number) {
    setTimeout(() => {
      this.mapService.map.invalidateSize({ animate: true, duration: 0.3 });
    }, waitTime);
  }

  hiddenHistoryMap() {
    this.vehicleHistoryDrawerService.setStateHiddenHistoryDrawer = true;
  }

  showHistoryMap() {
    this.vehicleHistoryDrawerService.setStateHiddenHistoryDrawer = false;
  }

  destroyedHistoryMap() {
    this.vehicleHistoryDrawerService.setStateDestroyedHistoryDrawer = true;
  }

  mapResize() {
    this.centerMap(400);
  }
}
